import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NglModule} from 'ng-lightning';
import { ConfigurableLinkListModule } from '../../../../common/component/configurable_link_list/configurable_link_list.module';
import { AlertModule } from '../../../../common/component/alert/alert.module';

import { ProcessSettingsComponent } from './process-settings.component';

@NgModule({
  imports: [
    CommonModule
    ,FormsModule
    ,DateInputsModule
    ,DropDownsModule
    ,NglModule
    ,ConfigurableLinkListModule
    ,AlertModule
  ],
  declarations: [ProcessSettingsComponent],
  exports: [ProcessSettingsComponent],
  schemas:[ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ProcessSettingsModule { }
